import React, { lazy } from "react";
import { RouteProps } from "react-router-dom";
import {
  loginPages,
  dashboardPagesMenu,
  demoPagesMenu,
  masterPageMenu,
  superAdminPageMenu,
  profilePageMenu,
  operationPageMenu,
  reportsPageMenu,
  leadsDashboardMenu,
} from "../menu";
import Login from "../pages/presentation/auth/Login";

const LANDING = {
  DASHBOARD: lazy(() => import("../pages/dashboard/LeadsDashboard")),
};

const DASHBOARD_LEADS = {
  DASHBOARD_PAGE: lazy(() => import("../pages/dashboard/LeadsDashboard")),
};

const ATTENDANCE = {
  ATTENDANCE_PAGE: lazy(
    () => import("../pages/operations/attendance/attendance.component"),
  ),
};
const PREPROPOSALS = {
  PREPROPOSALS_PAGE: lazy(
    () => import("../pages/operations/preproposals/preproposals.component"),
  ),
};

//*****************REPORTS PAGE START*************
const DIALLERPUSHLOG = {
  DIALLERPUSHLOG_PAGE: lazy(
    () => import("../pages/reports/diallerPushLog/diallerPushLog.component"),
  ),
};
const VIEWBUSINESSDETAILS = {
  VIEWBUSINESSDETAILS_PAGE: lazy(
    () => import("../pages/reports/viewBusinessDetails/ViewBusinessDetails"),
  ),
};
const CALLBACK = {
  CALLBACK_PAGE: lazy(
    () => import("../pages/reports/callBack/callBack.component"),
  ),
};
const WEBENQUIRY = {
  WEBENQUIRY_PAGE: lazy(
    () => import("../pages/reports/webEnquiry/WebEnquiry.Component"),
  ),
};
const SUBMITTEDPROPOSALS = {
  SUBMITTEDPROPOSALS_PAGE: lazy(
    () =>
      import("../pages/reports/submittedProposalsReport/submittedProposals.Component"),
  ),
};
const STATUSCOUNT = {
  STATUS_COUNT_PAGE: lazy(
    () => import("../pages/reports/status-count/status-count.component"),
  ),
};
const TCNRESPONSE = {
  TCNRESPONSE_PAGE: lazy(
    () => import("../pages/reports/tcnResponse/tcnResponse.component"),
  ),
};
const PERFORMANCREPORT = {
  PERFORMANCREPORT_PAGE: lazy(
    () =>
      import("../pages/reports/performanceReport/performanceReport.component"),
  ),
};
const RPCNONRPCREPORT = {
  RPCNONRPCREPORT_PAGE: lazy(
    () => import("../pages/reports/rpcReport/rpcNonReport.component"),
  ),
};
const AVERAGEMONTHLYPERFORMANCEREPORT = {
  AVERAGE_MONTHLY_PERFORMANCE_REPORT_PAGE: lazy(
    () =>
      import("../pages/reports/averageMonthlyPerformanceReport/averageMonthlyPerformanceReport.component"),
  ),
};
// const REQUESTREPORT = {
//   REQUEST_REPORT_PAGE: lazy(
//     () => import("../pages/reports/requestReport/requestReport"),
//   ),
// };
//*****************REPORTS PAGE START*************

const PROFILE = {
  PROFILE_PAGE: lazy(
    () => import("../pages/presentation/auth/profile/ProfilePage"),
  ),
};
const AUTH = {
  PAGE_404: lazy(() => import("../pages/presentation/auth/Page404")),
};
const APP = {
  CRM: {
    CUSTOMERS: lazy(() => import("../pages/presentation/crm/CustomersList")),
  },
};

const USERTYPE = {
  USERTYPE_PAGE: lazy(() => import("../pages/master/userType/UserTypePage")),
};
const USERACESSCONTROL = {
  ASSIGNUSERRIGHTS_PAGE: lazy(
    () => import("../pages/master/assign-users-rights/AssignUsersRightsPage"),
  ),
};

// const USERACESSCONTROL = {
//   ASSIGNUSERRIGHTS_PAGE: lazy(
//     () => import("../pages/master/branch/BranchPage"),
//   ),
// };

const BRANCH = {
  BRANCH_PAGE: lazy(() => import("../pages/master/branch/BranchPage")),
};

const DEPARTMENT = {
  DEPARTMENT_PAGE: lazy(
    () => import("../pages/master/department/DepartmentPage"),
  ),
};

const PRODUCT = {
  PRODUCT_PAGE: lazy(() => import("../pages/master/product/ProductPage")),
};

const LENDER = {
  LENDER_PAGE: lazy(() => import("../pages/master/lender/LenderPage")),
};

const STAFF = {
  STAFF_PAGE: lazy(() => import("../pages/master/staff/StaffPage")),
};
const LEADS = {
  LEADS_PAGE: lazy(() => import("../pages/master/leads/LeadsPage")),
};
const SECTOR = {
  PAGE: lazy(() => import("../pages/master/sector/SectorPage")),
};
const DISPOSITION = {
  PAGE: lazy(() => import("../pages/master/dispositionGroup/DispositionGroupPage")),
};
const SIC = {
  PAGE: lazy(() => import("../pages/master/sic/SicPage")),
};
const DATA_PROVIDER = {
  PAGE: lazy(() => import("../pages/master/dataProvider/DataProviderPage")),
};
const DIALER_CONFIG = {
  PAGE: lazy(() => import("../pages/master/dialerConfig/DialerConfigPage")),
};
const EMAIL_RULE = {
  PAGE: lazy(() => import("../pages/master/emailRule/EmailRulePage")),
};
const EMAIL_TEMPLATE = {
  PAGE: lazy(() => import("../pages/master/emailTemplate/EmailTemplatePage")),
};
const EMAIL_WORKFLOW = {
  PAGE: lazy(() => import("../pages/master/emailWorkflow/EmailWorkflowPage")),
};
const EMAIL_LOG = {
  PAGE: lazy(() => import("../pages/reports/emailLog/EmailLog.component")),
};
const STUCK_DEALS = {
  PAGE: lazy(() => import("../pages/reports/stuckDeals/StuckDeals.component")),
};
const REPORT_BUILDER = {
  PAGE: lazy(() => import("../pages/reports/reportBuilder/ReportBuilder.component")),
};
const STATUS_FIELDS = {
  PAGE: lazy(() => import("../pages/master/statusFields/StatusFieldsPage")),
};
const STATUS_MASTER = {
  PAGE: lazy(() => import("../pages/master/status/StatusMasterPage")),
};
const COMPANY = {
  COMPANY_PAGE: lazy(() => import("../pages/superAdmin/company/CompanyPage")),
};
const FUNDER = {
  FUNDER_PAGE: lazy(() => import("../pages/master/funder/FunderPage")),
};
const presentation: RouteProps[] = [
  /**
   * Landing
   */
  {
    path: dashboardPagesMenu.dashboard.path,
    element: <LANDING.DASHBOARD />,
  },

  /** ************************************************** */

  /** ********************* LOGIN START ***************************** */
  {
    path: profilePageMenu.profile.path,
    element: <PROFILE.PROFILE_PAGE />,
  },

  /** ********************* LOGIN END ***************************** */

  /** ********************* LOGIN START ***************************** */
  {
    path: loginPages.page404.path,
    element: <AUTH.PAGE_404 />,
  },
  {
    path: loginPages.login.path,
    element: <Login />,
  },
  // {
  // 	path: loginPages.signUp.path,
  // 	element: <Login isSignUp />,
  // },
  /** ********************* LOGIN END ***************************** */

  /** *********************  OPERATION START ***************************** */
  {
    path: operationPageMenu.operationPages.subMenu.Attendance.path,
    element: <ATTENDANCE.ATTENDANCE_PAGE />,
  },
  {
    path: operationPageMenu.operationPages.subMenu.preproposals.path,
    element: <PREPROPOSALS.PREPROPOSALS_PAGE />,
  },
  /** *********************  OPERATION END ***************************** */

  /** *********************  REPORTS START ***************************** */
  {
    path: reportsPageMenu.reportsPages.subMenu.diallerPushLogPage.path,
    element: <DIALLERPUSHLOG.DIALLERPUSHLOG_PAGE />,
  },
  {
    path: reportsPageMenu.reportsPages.subMenu.viewBusinessDetails.path,
    element: <VIEWBUSINESSDETAILS.VIEWBUSINESSDETAILS_PAGE />,
  },
  {
    path: reportsPageMenu.reportsPages.subMenu.callBack.path,
    element: <CALLBACK.CALLBACK_PAGE />,
  },
  {
    path: reportsPageMenu.reportsPages.subMenu.webEnquiryComponent.path,
    element: <WEBENQUIRY.WEBENQUIRY_PAGE />,
  },
  {
    path: reportsPageMenu.reportsPages.subMenu.submittedPrposalsComponent.path,
    element: <SUBMITTEDPROPOSALS.SUBMITTEDPROPOSALS_PAGE />,
  },
  {
    path: reportsPageMenu.reportsPages.subMenu.StatusCount.path,
    element: <STATUSCOUNT.STATUS_COUNT_PAGE />,
  },
  {
    path: reportsPageMenu.reportsPages.subMenu.tcnResponsePage.path,
    element: <TCNRESPONSE.TCNRESPONSE_PAGE />,
  },
  {
    path: reportsPageMenu.reportsPages.subMenu.performanceReport.path,
    element: <PERFORMANCREPORT.PERFORMANCREPORT_PAGE />,
  },
  {
    path: reportsPageMenu.reportsPages.subMenu.rpcNonReport.path,
    element: <RPCNONRPCREPORT.RPCNONRPCREPORT_PAGE />,
  },
  {
    path: reportsPageMenu.reportsPages.subMenu.averageMonthlyPerformanceReport
      .path,
    element: (
      <AVERAGEMONTHLYPERFORMANCEREPORT.AVERAGE_MONTHLY_PERFORMANCE_REPORT_PAGE />
    ),
  },
  // {
  //   path: reportsPageMenu.reportsPages.subMenu.RequestReport.path,
  //   element: <REQUESTREPORT.REQUEST_REPORT_PAGE />,
  // },
  /** *********************  REPORTS END ***************************** */

  //   const USERACESSCONTROL = {
  // 	ASSIGNUSERRIGHTS_PAGE: lazy(
  // 		() => import('../pages/user-controls-access/assign-users-rights/AssignUsersRightsPage'),
  // 	),
  // };

  /** ********************* MASTER START ***************************** */
  {
    path: masterPageMenu.masterPages.subMenu.userTypePage.path,
    element: <USERTYPE.USERTYPE_PAGE />,
  },

  {
    path: masterPageMenu.masterPages.subMenu.assignUserRights.path,
    element: <USERACESSCONTROL.ASSIGNUSERRIGHTS_PAGE />,
  },

  {
    path: masterPageMenu.masterPages.subMenu.branchPage.path,
    element: <BRANCH.BRANCH_PAGE />,
  },

  {
    path: masterPageMenu.masterPages.subMenu.departmentPage.path,
    element: <DEPARTMENT.DEPARTMENT_PAGE />,
  },

  {
    path: masterPageMenu.masterPages.subMenu.productPage.path,
    element: <PRODUCT.PRODUCT_PAGE />,
  },

  {
    path: masterPageMenu.masterPages.subMenu.lenderPage.path,
    element: <LENDER.LENDER_PAGE />,
  },

  {
    path: masterPageMenu.masterPages.subMenu.funderPage.path,
    element: <FUNDER.FUNDER_PAGE />,
  },
  {
    path: masterPageMenu.masterPages.subMenu.staffPage.path,
    element: <STAFF.STAFF_PAGE />,
  },
  {
    path: masterPageMenu.masterPages.subMenu.leadsPage.path,
    element: <LEADS.LEADS_PAGE />,
  },
  {
    // ISSUE-004: menu entry is hidden for soft launch; the route stays live
    // (direct URL) so QA can keep testing the module.
    path: "master-pages/status-fields",
    element: <STATUS_FIELDS.PAGE />,
  },
  {
    // ISSUE-004 Phase 2: Status master (create/edit statuses with required scope).
    path: "master-pages/status-master",
    element: <STATUS_MASTER.PAGE />,
  },
  {
    path: masterPageMenu.masterPages.subMenu.sectorPage.path,
    element: <SECTOR.PAGE />,
  },
  {
    path: masterPageMenu.masterPages.subMenu.dispositionPage.path,
    element: <DISPOSITION.PAGE />,
  },
  {
    path: masterPageMenu.masterPages.subMenu.sicPage.path,
    element: <SIC.PAGE />,
  },
  {
    path: masterPageMenu.masterPages.subMenu.dataProviderPage.path,
    element: <DATA_PROVIDER.PAGE />,
  },
  {
    path: masterPageMenu.masterPages.subMenu.dialerConfigPage.path,
    element: <DIALER_CONFIG.PAGE />,
  },
  {
    path: masterPageMenu.masterPages.subMenu.emailRulePage.path,
    element: <EMAIL_RULE.PAGE />,
  },
  {
    path: masterPageMenu.masterPages.subMenu.emailTemplatePage.path,
    element: <EMAIL_TEMPLATE.PAGE />,
  },
  {
    path: masterPageMenu.masterPages.subMenu.emailWorkflowPage.path,
    element: <EMAIL_WORKFLOW.PAGE />,
  },
  {
    path: reportsPageMenu.reportsPages.subMenu.emailLogPage.path,
    element: <EMAIL_LOG.PAGE />,
  },
  {
    path: reportsPageMenu.reportsPages.subMenu.stuckDealsPage.path,
    element: <STUCK_DEALS.PAGE />,
  },
  {
    path: reportsPageMenu.reportsPages.subMenu.reportBuilderPage.path,
    element: <REPORT_BUILDER.PAGE />,
  },
  {
    path: leadsDashboardMenu.pages.path,
    element: <DASHBOARD_LEADS.DASHBOARD_PAGE />,
  },

  /** ********************* MASTER END ***************************** */

  /** ********************* SUPER ADMIN START ***************************** */
  {
    path: superAdminPageMenu.superAdminPages.subMenu.companyPage.path,
    element: <COMPANY.COMPANY_PAGE />,
  },

  /** ********************* SUPER ADMIN END ****************************

    /** *********************  OPERATION START ***************************** */
  // {
  //   path: operationPageMenu.operationPages.subMenu.Attendance.path,
  //   element: <ATTENDANCE.ATTENDANCE_PAGE />,
  // },

  /** *********************  OPERATION END ***************************** */
  /**
   * App > CRM
   */
  {
    path: demoPagesMenu.crm.subMenu.customersList.path,
    element: <APP.CRM.CUSTOMERS />,
  },
  /**
   * END - App
   */

  /** ************************************************** */
];

const contents = [...presentation];

export default contents;
